<template>
  <div class="promote">
    <van-nav-bar
      :title="title"
      left-arrow
      fixed
      placeholder
      @click-left="onClickLeft"
    />



    <!-- 内容区域 -->
    <div class="content-area">
      <div v-if="isConter" style="padding: 0.2rem; font-size: 0.22rem">
        <div class="ejXficlz5ysFaJf0CHhl" v-html="content"></div>
      </div>
      <div
        v-else
        style="
          font-size: 0.22rem;
          padding: 0.2rem;
          color: var(--theme-text-color-darken);
        "
        v-html="content"
      ></div>
      <event></event>
    </div>

  </div>
</template>

<script>
import event from '@/components/event.vue';
import { useRedemptionCode, platformRebate } from '@/apis/modules/detail.js';
import { Dialog, Toast } from 'vant';
export default {
  components: {
    event
  },
  data() {
    return {
      title: '',
      content: '',
      isConter: false,
      inputValue: '',
      isFocused: false,
      isLoading: false
    };
  },
  created(e) {
    let { title, content, isConter } = this.$route.query;
    this.title = title;
    this.content = content;
    this.isConter = isConter;
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },

    // 处理输入事件
    handleInput(event) {
      this.inputValue = event.target.value;
    },

    // 处理聚焦事件
    handleFocus() {
      this.isFocused = true;
    },

    // 处理失焦事件
    handleBlur() {
      this.isFocused = false;
    },

    // 处理粘贴按钮点击
    async handlePaste() {
      try {
        if (navigator.clipboard && navigator.clipboard.readText) {
          const text = await navigator.clipboard.readText();
          this.inputValue = text;
          Toast.success('粘贴成功');
        } else {
          Toast.info('请手动粘贴内容');
        }
      } catch (error) {
        console.error('粘贴失败:', error);
        Toast.fail('粘贴失败，请手动输入');
      }
    },

    // 验证输入内容
    validateInput() {
      const value = this.inputValue.trim();

      if (!value) {
        Toast.fail('请输入兑换码');
        return false;
      }

      return true;
    },

    // 提交处理
    handleSubmit() {
      if (!this.validateInput()) {
        return;
      }

      this.isLoading = true;

      try {
        // useRedemptionCode({ code: this.inputValue.trim() }).then(({ code, data, msg }) => {
        useRedemptionCode({ code: this.inputValue.trim() }).then(
          ({ code, data, msg }) => {
            if (code == 0) {
              Dialog({
                title: 'Recebimento com sucesso',
                message: data
              });
              return;
            }
            Dialog({
              title: '',
              message: msg
            });
          }
        );
      } catch (error) {
        console.error('兑换失败:', error);
        Toast.fail.error('兑换失败，请稍后重试');
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>

<style scoped>
:deep(.van-nav-bar__placeholder) {
  height: 0.9rem;
}
.ejXficlz5ysFaJf0CHhl {
  background-color: var(--theme-main-bg-color);
  min-height: 5.8rem;
  padding: 0.2rem;
  word-break: break-word;
  color: var(--theme-text-color);
  border-radius: 0.14rem;
  box-shadow: 0 0.03rem 0.1rem 0 rgba(0, 0, 0, 0.06);
}

/* 输入框样式 */
.top-content {
  border-radius: 0.16rem;
  margin: 0.2rem;
  padding: 0.32rem;
}

.box-shadow {
  box-shadow: 0 0.04rem 0.16rem rgba(0, 0, 0, 0.1);
}

._input_1ywvk_30 {
  width: 100%;
}

.ui-input {
  display: flex;
  align-items: center;
  border-radius: 0.16rem;
  padding: 0 0.24rem;
  min-height: 0.88rem;
  border: 0.02rem solid #e0e0e0;
  transition: all 0.3s ease;
}

.ui-input--focused {
  border-color: #1890ff;
  box-shadow: 0 0 0 0.04rem rgba(24, 144, 255, 0.2);
}

.ui-input__prefix {
  display: flex;
  align-items: center;
  margin-right: 0.16rem;
  color: #666;
}

.ui-input__input-wrap {
  flex: 1;
  display: flex;
  align-items: center;
}

.ui-input__input-container {
  width: 100%;
}

.ui-input__input {
  width: 100%;
  border: none;
  outline: none;
  background: transparent;
  font-size: 0.28rem;
  color: #fff;
  padding: 0;
}

.ui-input__input::placeholder {
  color: #999;
}

.ui-input__suffix {
  display: flex;
  align-items: center;
  margin-left: 0.16rem;
  gap: 0.16rem;
}

.ui-input__suffix-icon {
  cursor: pointer;
  padding: 0.08rem 0.16rem;
  border-radius: 0.08rem;
  transition: background-color 0.3s ease;
}

.ui-input__suffix-icon:hover {
  background-color: rgba(24, 144, 255, 0.1);
}

.ui-paste__text {
  color: #1890ff;
  font-size: 0.24rem;
  font-weight: 500;
}

/* 内容区域样式 */
.content-area {
  padding-bottom: 1.6rem; /* 为底部按钮留出空间 */
}

/* 底部固定按钮容器 */
.bottom-fixed-btn {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 0.32rem;
  background: var(--theme-active-bg-color);
  box-shadow: 0 -0.04rem 0.16rem rgba(0, 0, 0, 0.1);
  z-index: 1000;
  padding-bottom: calc(0.32rem + env(safe-area-inset-bottom));
}

/* 固定按钮样式 */
.submit-btn-fixed {
  width: 100%;
  height: 0.96rem;
  background: linear-gradient(135deg, #1890ff, #40a9ff);
  color: white;
  border: none;
  border-radius: 0.16rem;
  font-size: 0.32rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.16rem;
}

.submit-btn-fixed:hover {
  background: linear-gradient(135deg, #40a9ff, #69c0ff);
  transform: translateY(-0.02rem);
  box-shadow: 0 0.08rem 0.24rem rgba(24, 144, 255, 0.3);
}

.submit-btn-fixed:active {
  transform: translateY(0);
  background: linear-gradient(135deg, #096dd9, #1890ff);
}

.submit-btn-fixed:disabled {
  background: #d9d9d9;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.loading-spinner {
  width: 0.24rem;
  height: 0.24rem;
  border: 0.04rem solid #fff;
  border-top: 0.04rem solid transparent;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.lobby-image svg {
  width: 0.4rem;
  height: 0.4rem;
}
</style>
